import * as actionlist from '../actions/invoicereportlistactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,
    month: moment().month() + 1,
    year: moment().year(),
    monthend: moment().month() + 1,
    yearend: moment().year(),
    client: null
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    month: state => state.month,
    year: state => state.year,
    monthend: state => state.monthend,
    yearend: state => state.yearend,
    client: state => state.client
};

const actions = {
    [actionlist.INVOICEREPORTLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.INVOICEREPORTLIST_SEARCH, search);
    },
    [actionlist.INVOICEREPORTLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.INVOICEREPORTLIST_PAGE, page);
    },
    [actionlist.INVOICEREPORTLIST_MONTH]: ({ commit }, month) => {
        commit(actionlist.INVOICEREPORTLIST_MONTH, month);
    },
    [actionlist.INVOICEREPORTLIST_YEAR]: ({ commit }, year) => {
        commit(actionlist.INVOICEREPORTLIST_YEAR, year);
    },
    [actionlist.INVOICEREPORTLIST_MONTHEND]: ({ commit }, monthend) => {
        commit(actionlist.INVOICEREPORTLIST_MONTHEND, monthend);
    },
    [actionlist.INVOICEREPORTLIST_YEAREND]: ({ commit }, yearend) => {
        commit(actionlist.INVOICEREPORTLIST_YEAREND, yearend);
    },
    [actionlist.INVOICEREPORTLIST_CLIENT]: ({ commit }, client) => {
        commit(actionlist.INVOICEREPORTLIST_CLIENT, client);
    },
};

const mutations = {
    [actionlist.INVOICEREPORTLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.INVOICEREPORTLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionlist.INVOICEREPORTLIST_MONTH]: (state, month) => {
        state.page = 0;
        state.month = month;
    },
    [actionlist.INVOICEREPORTLIST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },
    [actionlist.INVOICEREPORTLIST_MONTHEND]: (state, monthend) => {
        state.page = 0;
        state.monthend = monthend;
    },
    [actionlist.INVOICEREPORTLIST_YEAREND]: (state, yearend) => {
        state.page = 0;
        state.yearend = yearend;
    },
    [actionlist.INVOICEREPORTLIST_CLIENT]: (state, client) => {
        state.page = 0;
        state.client = client;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};